import { render, staticRenderFns } from "./MultimediaCard.vue?vue&type=template&id=0280e4fe&"
import script from "./MultimediaCard.vue?vue&type=script&lang=js&"
export * from "./MultimediaCard.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports